import { render, staticRenderFns } from "./Electiondashboard.vue?vue&type=template&id=49343631"
import script from "./Electiondashboard.vue?vue&type=script&lang=js"
export * from "./Electiondashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports